import { QuestionCore } from '../../types'

export const TIJDGELD_QUESTIONS: QuestionCore[] = [
  // PATRONEN HERKENNEN (expanded to 6 questions: 2x M6, 2x M6+, 2x E6)
  {
    id: 'TIJD-PAT-L1-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'patronen',
    familyId: 'TIJD-PAT-REEKS',
    difficulty: 1,
    question: 'Kijk naar de rij: 3 - 7 - 11 - 15 - ... Welk getal komt daarna?',
    options: ['19', '16', '18', '20'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-PAT-L1-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'patronen',
    familyId: 'TIJD-PAT-VERMENIGVULDIG',
    difficulty: 1,
    question: 'Kijk naar de rij: 2 - 4 - 8 - 16 - ... Welk getal komt daarna?',
    options: ['32', '24', '20', '18'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-PAT-L2-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'patronen',
    familyId: 'TIJD-PAT-ZAKGELD',
    difficulty: 2,
    question:
      'Toms zakgeld: Week 1: €2. Week 2: €4. Week 3: €6. Hoeveel krijgt hij in Week 5?',
    options: ['€ 10', '€ 8', '€ 12', '€ 5'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-PAT-L2-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'patronen',
    familyId: 'TIJD-PAT-SPRINGEN',
    difficulty: 2,
    question: 'Welk getal past in de rij: 5 - 10 - 20 - ... - 80?',
    options: ['40', '30', '50', '60'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-PAT-L3-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'patronen',
    familyId: 'TIJD-PAT-FIBONACCI',
    difficulty: 3,
    question:
      'Kijk naar de rij: 1 - 1 - 2 - 3 - 5 - 8 - ... Welk getal komt daarna?',
    options: ['13', '11', '10', '16'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-PAT-L3-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'patronen',
    familyId: 'TIJD-PAT-COMPLEX',
    difficulty: 3,
    question: 'Welk getal past in de rij: 100 - 90 - 81 - 73 - ... - 60?',
    options: ['66', '67', '65', '68'],
    correctAnswer: 0,
  },

  // TABELLEN LEZEN (expanded to 8 questions)
  {
    id: 'TIJD-TAB-L1-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-TEMPERATUUR',
    difficulty: 1,
    question:
      'In een tabel staat: Maandag 5 graden, Dinsdag 8 graden, Woensdag 6 graden. Op welke dag was het het warmst?',
    options: ['Dinsdag', 'Maandag', 'Woensdag', 'Alle dagen gelijk'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L1-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-PUNTEN',
    difficulty: 1,
    question:
      'Voetbalstand: Ajax 12 punten, PSV 15 punten, Feyenoord 10 punten. Welk team staat bovenaan?',
    options: ['PSV', 'Ajax', 'Feyenoord', 'Alle gelijk'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L1-003',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-LENGTE',
    difficulty: 1,
    question:
      'Lengte tabel: Lisa 145 cm, Tom 152 cm, Emma 148 cm. Wie is het langst?',
    options: ['Tom', 'Lisa', 'Emma', 'Lisa en Emma'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L2-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-VERSCHIL',
    difficulty: 2,
    question:
      'Toets resultaten: Klas A gemiddeld 7,5. Klas B gemiddeld 8,2. Hoeveel hoger scoort klas B?',
    options: ['0,7 punt', '0,5 punt', '1,0 punt', '0,3 punt'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L2-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-TOTAAL',
    difficulty: 2,
    question:
      'Verkoop tabel: Maandag 15 broodjes, Dinsdag 23 broodjes, Woensdag 18 broodjes. Hoeveel in totaal?',
    options: ['56 broodjes', '46 broodjes', '66 broodjes', '38 broodjes'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L3-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-MENU',
    difficulty: 3,
    question:
      'Op de menukaart staat: Pannenkoek € 5,00. Toeslag spek: + € 1,50. Toeslag kaas: + € 1,00. Je bestelt een pannenkoek met spek én kaas. Wat betaal je?',
    options: ['€ 7,50', '€ 6,50', '€ 6,00', '€ 8,50'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L3-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-AFSTAND',
    difficulty: 3,
    question:
      'Afstandstabel: Van A naar B is 10 km. Van B naar C is 5 km. Van A naar C (via B) is ... km?',
    options: ['15 km', '5 km', '50 km', '20 km'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L3-003',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tabellen',
    familyId: 'TIJD-TAB-GEMIDDELDE',
    difficulty: 3,
    question:
      'Cijfers: Toets 1: 7, Toets 2: 8, Toets 3: 6. Wat is het gemiddelde cijfer?',
    options: ['7,0', '7,5', '6,5', '8,0'],
    correctAnswer: 0,
  },

  // TIJD REKENEN/DUUR (expanded to 6 questions)
  {
    id: 'TIJD-DUR-L1-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-DUR-KWARTIER',
    difficulty: 1,
    question: 'Het is nu 14:00. Over een kwartier is het...',
    options: ['14:15', '14:30', '15:00', '14:45'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-DUR-L1-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-DUR-HALF-UUR',
    difficulty: 1,
    question:
      'De film begint om 19:30 en duurt 1 uur. Hoe laat is de film afgelopen?',
    options: ['20:30', '20:00', '21:00', '19:00'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-DUR-L2-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-DUR-TREIN',
    difficulty: 2,
    question:
      'De trein vertrekt elk half uur. De eerste trein gaat om 09:15. Hoe laat gaat de volgende?',
    options: ['09:45', '09:30', '10:15', '09:55'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-DUR-L2-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-DUR-REISTIJD',
    difficulty: 2,
    question:
      'Je vertrekt om 08:45 en komt aan om 10:15. Hoe lang heb je gereisd?',
    options: ['1 uur en 30 minuten', '1 uur en 15 minuten', '2 uur', '1 uur'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-DUR-L3-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-DUR-MEERDERE',
    difficulty: 3,
    question:
      'Een concert begint om 19:45 en duurt 2 uur en 35 minuten. Hoe laat is het afgelopen?',
    options: ['22:20', '22:10', '21:20', '22:30'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-DUR-L3-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-DUR-TERUGREKENEN',
    difficulty: 3,
    question:
      'De les eindigt om 11:30. De les duurde 1 uur en 45 minuten. Hoe laat begon de les?',
    options: ['09:45', '10:15', '09:30', '10:00'],
    correctAnswer: 0,
  },

  // KLOKKIJKEN TOT OP DE SECONDE (keep existing 9 questions)
  {
    id: 'TIJD-KLOK-L1-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_seconden',
    familyId: 'TIJD-KLOK-SECONDE-BASIS',
    difficulty: 1,
    question: 'Hoeveel seconden zitten er in 1 minuut?',
    options: ['60 seconden', '100 seconden', '30 seconden', '120 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L1-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_digitaal',
    familyId: 'TIJD-KLOK-DIGITAAL',
    difficulty: 1,
    question: 'De digitale klok toont: 14:30:00. Hoe laat is het?',
    options: [
      "Half drie 's middags",
      "Half twee 's middags",
      "Drie uur 's middags",
      "Half vier 's middags",
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L1-003',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_seconden',
    familyId: 'TIJD-KLOK-HALF-MINUUT',
    difficulty: 1,
    question: 'Hoeveel seconden zitten er in een half minuut?',
    options: ['30 seconden', '60 seconden', '15 seconden', '45 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L2-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_seconden',
    familyId: 'TIJD-KLOK-NA-KWARTIER',
    difficulty: 2,
    question:
      'De klok toont 09:15:30. Hoeveel seconden is het na kwart over negen?',
    options: ['30 seconden', '15 seconden', '45 seconden', '1 minuut'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L2-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-KLOK-RACE',
    difficulty: 2,
    question:
      'Een race duurt 2 minuten en 45 seconden. Hoeveel seconden is dat in totaal?',
    options: ['165 seconden', '145 seconden', '245 seconden', '125 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L2-003',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-KLOK-AFTELLEN',
    difficulty: 2,
    question:
      'De klok staat op 11:58:40. Over hoeveel seconden is het 12:00:00?',
    options: ['80 seconden', '60 seconden', '120 seconden', '20 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L3-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-KLOK-ATLEET',
    difficulty: 3,
    question:
      'Een atleet loopt 400 meter in 58,75 seconden. Hoeveel is dat in minuten en seconden?',
    options: [
      '0 minuten en 58,75 seconden',
      '58 minuten en 75 seconden',
      '5 minuten en 8,75 seconden',
      '0 minuten en 59 seconden',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L3-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-KLOK-MIDDERNACHT',
    difficulty: 3,
    question:
      'De klok toont 23:59:45. Over hoeveel seconden begint de nieuwe dag?',
    options: ['15 seconden', '45 seconden', '60 seconden', '30 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L3-003',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'tijd_rekenen',
    familyId: 'TIJD-KLOK-LIEDJE',
    difficulty: 3,
    question:
      'Een liedje duurt 3 minuten en 15 seconden. Hoeveel seconden is dat in totaal?',
    options: ['195 seconden', '315 seconden', '180 seconden', '215 seconden'],
    correctAnswer: 0,
  },

  // KLOKKIJKEN INTERACTIEF (NEW)
  {
    id: 'TIJD-KLOK-INT-L1-001',
    module: 'TijdGeld',
    questionType: 'klok_aflezen',
    skill: 'tijdgeld',
    subSkill: 'tijd_seconden',
    familyId: 'TIJD-KLOK-INT-BASIS',
    difficulty: 1,
    question: 'Hoe laat is het op de klok?',
    // Option 0 is correct answer. Others are distractors for validation matching
    options: ['14:30:00', '02:30:00', '14:06:00', '15:30:00'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-INT-L2-001',
    module: 'TijdGeld',
    questionType: 'klok_aflezen',
    skill: 'tijdgeld',
    subSkill: 'tijd_seconden',
    familyId: 'TIJD-KLOK-INT-SEC',
    difficulty: 2,
    question: 'Hoe laat is het precies?',
    options: ['09:15:30', '09:03:06', '21:15:30', '09:30:15'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-INT-L3-001',
    module: 'TijdGeld',
    questionType: 'klok_aflezen',
    skill: 'tijdgeld',
    subSkill: 'tijd_seconden',
    familyId: 'TIJD-KLOK-INT-COMPLEX',
    difficulty: 3,
    question: 'Hoe laat is het? Let goed op de secondewijzer!',
    options: ['11:58:45', '11:58:09', '12:58:45', '10:58:45'],
    correctAnswer: 0,
  },

  // GELD SAMENSTELLEN (reduced from 5 levels to 3: M6, M6+, E6)
  {
    id: 'GELD-SAMEN-L1-001',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-BASIC-1',
    difficulty: 1,
    question: 'Maak precies €1,50',
    options: ['100', '50', '20', '10', '5'],
    correctAnswer: 150,
  },
  {
    id: 'GELD-SAMEN-L1-002',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-BASIC-2',
    difficulty: 1,
    question: 'Maak precies €2,50',
    options: ['200', '100', '50', '20', '10'],
    correctAnswer: 250,
  },
  {
    id: 'GELD-SAMEN-L1-003',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-BASIC-3',
    difficulty: 1,
    question: 'Maak precies €3,75',
    options: ['200', '100', '50', '20', '10', '5'],
    correctAnswer: 375,
  },
  {
    id: 'GELD-SAMEN-L2-001',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-COMBO-1',
    difficulty: 2,
    question: 'Maak precies €5,25',
    options: ['500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 525,
  },
  {
    id: 'GELD-SAMEN-L2-002',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-COMBO-2',
    difficulty: 2,
    question: 'Maak precies €8,65',
    options: ['500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 865,
  },
  {
    id: 'GELD-SAMEN-L2-003',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-COMBO-3',
    difficulty: 2,
    question: 'Maak precies €12,85',
    options: ['1000', '500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 1285,
  },
  {
    id: 'GELD-SAMEN-L3-001',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-ADVANCED-1',
    difficulty: 3,
    question: 'Maak precies €18,70',
    options: ['1000', '500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 1870,
  },
  {
    id: 'GELD-SAMEN-L3-002',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-ADVANCED-2',
    difficulty: 3,
    question: 'Maak precies €23,45',
    options: ['2000', '1000', '500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 2345,
  },
  {
    id: 'GELD-SAMEN-L3-003',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'geld_samenstellen',
    familyId: 'GELD-SAMEN-ADVANCED-3',
    difficulty: 3,
    question: 'Maak precies €31,25',
    options: ['2000', '1000', '500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 3125,
  },

  // WISSELGELD BEREKENEN (interactive: 9 questions with geld_samenstellen)
  {
    id: 'GELD-WISSEL-L1-001',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-SIMPEL-1',
    difficulty: 1,
    question:
      'Je koopt iets van € 3,00 en betaalt met € 5,00. Maak het wisselgeld',
    options: ['200', '100', '50', '20', '10', '5'],
    correctAnswer: 200,
  },
  {
    id: 'GELD-WISSEL-L1-002',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-SIMPEL-2',
    difficulty: 1,
    question:
      'Een broodje kost € 2,50. Je betaalt met € 5,00. Maak het wisselgeld',
    options: ['200', '100', '50', '20', '10', '5'],
    correctAnswer: 250,
  },
  {
    id: 'GELD-WISSEL-L1-003',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-SIMPEL-3',
    difficulty: 1,
    question:
      'Je betaalt € 1,50 voor een pen met een briefje van € 2,00. Maak het wisselgeld',
    options: ['50', '20', '10', '5', '2', '1'],
    correctAnswer: 50,
  },
  {
    id: 'GELD-WISSEL-L2-001',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-MEDIUM-1',
    difficulty: 2,
    question:
      'Een boek kost € 12,75. Je betaalt met € 20,00. Maak het wisselgeld',
    options: ['500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 725,
  },
  {
    id: 'GELD-WISSEL-L2-002',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-MEDIUM-2',
    difficulty: 2,
    question:
      'Je koopt voor € 8,35 en betaalt met € 10,00. Maak het wisselgeld',
    options: ['200', '100', '50', '20', '10', '5'],
    correctAnswer: 165,
  },
  {
    id: 'GELD-WISSEL-L2-003',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-MEDIUM-3',
    difficulty: 2,
    question:
      'Een speelgoed kost € 15,60. Je geeft € 20,00. Maak het wisselgeld',
    options: ['500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 440,
  },
  {
    id: 'GELD-WISSEL-L3-001',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-COMPLEX-1',
    difficulty: 3,
    question:
      'Je koopt iets van € 27,85 en betaalt met € 50,00. Maak het wisselgeld',
    options: ['2000', '1000', '500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 2215,
  },
  {
    id: 'GELD-WISSEL-L3-002',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-COMPLEX-2',
    difficulty: 3,
    question:
      'Een jas kost € 43,95. Je betaalt met 2 briefjes van € 20 en 1 van € 10. Maak het wisselgeld',
    options: ['500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 605,
  },
  {
    id: 'GELD-WISSEL-L3-003',
    module: 'TijdGeld',
    questionType: 'geld_samenstellen',
    skill: 'tijdgeld',
    subSkill: 'wisselgeld',
    familyId: 'GELD-WISSEL-COMPLEX-3',
    difficulty: 3,
    question:
      'Je betaalt € 38,70 voor schoenen met een briefje van € 50,00. Maak het wisselgeld',
    options: ['1000', '500', '200', '100', '50', '20', '10', '5'],
    correctAnswer: 1130,
  },

  // PRIJZEN VERGELIJKEN (new: 6 questions)
  {
    id: 'GELD-PRIJS-L1-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'prijzen_vergelijken',
    familyId: 'GELD-PRIJS-SIMPEL-1',
    difficulty: 1,
    question:
      'Een appel kost € 0,50. Een banaan kost € 0,35. Wat is goedkoper?',
    options: ['Banaan', 'Appel', 'Even duur', 'Kan niet zeggen'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-PRIJS-L1-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'prijzen_vergelijken',
    familyId: 'GELD-PRIJS-SIMPEL-2',
    difficulty: 1,
    question:
      'Winkel A: melk € 1,20. Winkel B: melk € 1,50. Waar is het goedkoper?',
    options: ['Winkel A', 'Winkel B', 'Even duur', 'Winkel A en B'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-PRIJS-L2-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'prijzen_vergelijken',
    familyId: 'GELD-PRIJS-MEDIUM-1',
    difficulty: 2,
    question:
      'Pak A: 6 eieren voor € 2,40. Pak B: 10 eieren voor € 3,50. Welk pak is voordeliger per ei?',
    options: ['Pak B', 'Pak A', 'Even duur', 'Kan niet berekenen'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-PRIJS-L2-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'prijzen_vergelijken',
    familyId: 'GELD-PRIJS-MEDIUM-2',
    difficulty: 2,
    question:
      'Fles A: 1 liter sap voor € 2,00. Fles B: 1,5 liter sap voor € 2,70. Welke is voordeliger per liter?',
    options: ['Fles A', 'Fles B', 'Even duur', 'Fles A en B'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-PRIJS-L3-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'prijzen_vergelijken',
    familyId: 'GELD-PRIJS-COMPLEX-1',
    difficulty: 3,
    question:
      'Actie: 3 halen, 2 betalen. Normaal € 4,50 per stuk. Hoeveel bespaar je als je 3 stuks koopt?',
    options: ['€ 4,50', '€ 9,00', '€ 3,00', '€ 13,50'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-PRIJS-L3-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'prijzen_vergelijken',
    familyId: 'GELD-PRIJS-COMPLEX-2',
    difficulty: 3,
    question:
      'Winkel A: 25% korting op € 40. Winkel B: vaste prijs € 28. Waar is het goedkoper?',
    options: ['Winkel B', 'Winkel A', 'Even duur', 'Winkel A en B'],
    correctAnswer: 0,
  },

  // BOODSCHAPPEN/TOTAALBEDRAG (new: 6 questions)
  {
    id: 'GELD-BOOD-L1-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'boodschappen',
    familyId: 'GELD-BOOD-SIMPEL-1',
    difficulty: 1,
    question:
      'Je koopt brood voor € 2,00 en melk voor € 1,50. Wat is het totaal?',
    options: ['€ 3,50', '€ 3,00', '€ 4,00', '€ 2,50'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-BOOD-L1-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'boodschappen',
    familyId: 'GELD-BOOD-SIMPEL-2',
    difficulty: 1,
    question: 'Een appel kost € 0,50. Je koopt 4 appels. Hoeveel betaal je?',
    options: ['€ 2,00', '€ 1,50', '€ 2,50', '€ 4,00'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-BOOD-L2-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'boodschappen',
    familyId: 'GELD-BOOD-MEDIUM-1',
    difficulty: 2,
    question:
      'Je koopt: kaas € 3,75, ham € 2,50, brood € 1,80. Wat is het totaalbedrag?',
    options: ['€ 8,05', '€ 7,05', '€ 8,50', '€ 7,50'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-BOOD-L2-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'boodschappen',
    familyId: 'GELD-BOOD-MEDIUM-2',
    difficulty: 2,
    question:
      'Een pak koekjes kost € 2,25. Je koopt 3 pakken. Hoeveel betaal je in totaal?',
    options: ['€ 6,75', '€ 6,25', '€ 7,25', '€ 5,75'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-BOOD-L3-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'boodschappen',
    familyId: 'GELD-BOOD-COMPLEX-1',
    difficulty: 3,
    question:
      'Je koopt: 2 broden à € 2,35, 3 pakken melk à € 1,15, en kaas voor € 4,80. Wat is het totaal?',
    options: ['€ 13,15', '€ 12,15', '€ 14,15', '€ 13,50'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-BOOD-L3-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'boodschappen',
    familyId: 'GELD-BOOD-COMPLEX-2',
    difficulty: 3,
    question:
      'Boodschappenlijst: vlees € 8,95, groente € 3,45, fruit € 4,60, drinken € 5,20. Totaal?',
    options: ['€ 22,20', '€ 21,20', '€ 23,20', '€ 22,00'],
    correctAnswer: 0,
  },

  // SPAREN EN BUDGETTEREN (new: 6 questions)
  {
    id: 'GELD-SPAAR-L1-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'sparen',
    familyId: 'GELD-SPAAR-SIMPEL-1',
    difficulty: 1,
    question:
      'Je hebt € 10,00 gespaard. Je krijgt € 5,00 zakgeld. Hoeveel heb je nu?',
    options: ['€ 15,00', '€ 5,00', '€ 10,00', '€ 20,00'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-SPAAR-L1-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'sparen',
    familyId: 'GELD-SPAAR-SIMPEL-2',
    difficulty: 1,
    question:
      'Een speelgoed kost € 20,00. Je hebt € 12,00. Hoeveel moet je nog sparen?',
    options: ['€ 8,00', '€ 10,00', '€ 6,00', '€ 32,00'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-SPAAR-L2-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'sparen',
    familyId: 'GELD-SPAAR-MEDIUM-1',
    difficulty: 2,
    question:
      'Je krijgt elke week € 5,00 zakgeld. Na hoeveel weken heb je € 30,00 gespaard?',
    options: ['6 weken', '5 weken', '7 weken', '4 weken'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-SPAAR-L2-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'sparen',
    familyId: 'GELD-SPAAR-MEDIUM-2',
    difficulty: 2,
    question:
      'Je hebt € 45,00. Een game kost € 35,00. Hoeveel houd je over na aankoop?',
    options: ['€ 10,00', '€ 15,00', '€ 5,00', '€ 80,00'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-SPAAR-L3-001',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'sparen',
    familyId: 'GELD-SPAAR-COMPLEX-1',
    difficulty: 3,
    question:
      'Je wilt een fiets van € 180,00. Je hebt € 75,00 en spaart € 15,00 per maand. Na hoeveel maanden kun je de fiets kopen?',
    options: ['7 maanden', '6 maanden', '8 maanden', '12 maanden'],
    correctAnswer: 0,
  },
  {
    id: 'GELD-SPAAR-L3-002',
    module: 'TijdGeld',
    questionType: 'multiple_choice',
    skill: 'tijdgeld',
    subSkill: 'sparen',
    familyId: 'GELD-SPAAR-COMPLEX-2',
    difficulty: 3,
    question:
      'Je budget is € 50,00. Je koopt een boek voor € 12,50 en een game voor € 28,75. Hoeveel blijft over?',
    options: ['€ 8,75', '€ 9,75', '€ 7,75', '€ 10,75'],
    correctAnswer: 0,
  },
]
